import { type ChangeEvent, type ReactNode, type RefObject } from 'react';

interface ImageFilePickerProps {
  children: ReactNode;
  onFile: (file: File | null) => void;
  disabled?: boolean;
  className?: string;
  inputRef?: RefObject<HTMLInputElement | null>;
  'aria-label'?: string;
}

/**
 * Native file input on top of the visible control.
 * Programmatic `input.click()` from HeroUI `onPress` is ignored on iOS/PWA,
 * so the photo appears not to attach.
 */
export function ImageFilePicker({
  children,
  onFile,
  disabled = false,
  className,
  inputRef,
  'aria-label': ariaLabel = 'Selecionar foto',
}: ImageFilePickerProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onFile(event.target.files?.[0] ?? null);
  };

  return (
    <div className={`relative inline-flex ${className ?? ''}`.trim()}>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,image/heic,image/heif"
        disabled={disabled}
        aria-label={ariaLabel}
        className="absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
        onChange={handleChange}
      />
      <div className="pointer-events-none">{children}</div>
    </div>
  );
}
